import { errorCodes, type ErrorCode } from '@seenaly/shared';
import type { Dict } from '@/i18n';
import { ApiError } from './api';

function isErrorCode(value: string): value is ErrorCode {
  return (errorCodes as readonly string[]).includes(value);
}

/**
 * Turns whatever went wrong into text in the user's language.
 *
 * The server sends codes, never prose (docs/spec.md §5), so translation happens
 * here. An unrecognised code falls back to the generic message rather than
 * leaking the English developer string to clinic staff.
 */
export function errorMessage(error: unknown, t: Dict): string {
  if (error instanceof ApiError && isErrorCode(error.code)) {
    return t.errors[error.code];
  }
  return t.common.error;
}
